import { useEffect, useState } from 'react'
import { supabase } from '../../../lib/supabase'

const CLUB_ID = 'a0000000-0000-0000-0000-000000000001'

function getInitials(name) {
  return name?.split(' ').filter(Boolean).map((n) => n[0]).join('').toUpperCase().slice(0, 2)
}

export default function Executives() {
  const [executives, setExecutives] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase
      .from('executives')
      .select('id, name, position, photo_url, sort_order')
      .eq('club_id', CLUB_ID)
      .order('sort_order', { ascending: true })
      .then(({ data }) => {
        if (data) setExecutives(data)
        setLoading(false)
      })
  }, [])

  if (loading || executives.length === 0) return null

  return (
    <section className="px-4 sm:px-8 py-12 sm:py-20">
      <div className="mb-6 sm:mb-10">
        <h2 className="text-2xl sm:text-3xl font-black uppercase tracking-tight text-gray-900 dark:text-white">
          Meet the Executives
        </h2>
        <p className="text-gray-500 text-sm mt-2">
          The leadership guiding the Mufulira Wanderers Supporters Society.
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
        {executives.map((exec, index) => (
          <div
            key={exec.id}
            className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 hover:border-green-400 dark:hover:border-green-700 hover:bg-green-50 dark:hover:bg-green-900/10 p-5 sm:p-6 flex flex-col items-center text-center transition-all group"
          >
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full overflow-hidden bg-green-900/50 border-2 border-green-700/40 group-hover:border-green-500/60 flex items-center justify-center mb-4 shrink-0 transition-all">
              {exec.photo_url
                ? <img src={exec.photo_url} alt={exec.name} className="w-full h-full object-cover" />
                : <span className="text-white font-black text-lg">{getInitials(exec.name)}</span>
              }
            </div>
            <div className="text-xs font-bold text-green-600 dark:text-green-400 uppercase tracking-widest mb-1 leading-tight">
              {exec.position}
            </div>
            <div className="text-sm font-black text-gray-900 dark:text-white uppercase tracking-tight leading-tight">
              {exec.name}
            </div>
            {index === 0 && (
              <div className="mt-2 bg-green-600 text-white text-xs font-bold uppercase tracking-widest px-2 py-0.5">Chair</div>
            )}
            {index === 1 && (
              <div className="mt-2 bg-green-900/60 border border-green-700/50 text-green-400 text-xs font-bold uppercase tracking-widest px-2 py-0.5">Vice</div>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}